import React from 'react';
import moment from "moment";
import _ from "lodash";
import { connect } from 'react-redux';

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {ASSET_MODAL_TYPE_NEW, newDesignInputCustomClassesViewOnly, OTHER_FINANCIAL_CATEGORY} from "../../../constants";
import {BaseNumberFormat} from "../../../../../components/Inputs";
import {PortfolioManagerResource} from "../../../../../utils/api";
import {displayErrorSnackBar, displaySuccessSnackBar} from "../../../../../components/SnackbarProvider/actions";
import PrimaryButton from "../../../../../components/Buttons/PrimaryButton";
import {FORM_FIELD_HEIGHT} from "../../../../TransactionsMonitoring/components/Filters/components/common_styles";
import {useTabsSharedDataContext} from "../../../../CustomerDashboardV2/components_v2/TabsSharedData/TabsSharedData";
import {dateToMoment, momentToDate} from "../../utils";
import {DisabledCategoryTooltipWrapper} from "../DisabledCategoryTooltipWrapper";


const calcValue = (qty, price) => _.round(qty * price, 2) || undefined;

const ExternalAssetForm = (props) => {

  const {
    dispatch,
    handleFormChange,
    defaults,
    errors,
    viewOnly,
    customerId,
  } = props;

  const [model, setModel] = React.useState({
    isin: defaults.isin,
    name: defaults.name,
    custodian: defaults.custodian,
    quantity: defaults.quantity,
    price: defaults.price,
    price_date: dateToMoment(defaults.price_date),
    value: defaults.value,
    buy_price: defaults.buy_price,
    buy_date: dateToMoment(defaults.buy_date),
    updated: dateToMoment(defaults.updated),
  });
  const [lastSearchedISIN, setLastSearchedISIN] = React.useState();
  const sharedData = useTabsSharedDataContext();

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      price_date: momentToDate(model.price_date),
      buy_date: momentToDate(model.buy_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    // we need store value in local variable cause event.target might be changed when setModel callback will be executed
    const newData = {[field]: value};

    if (field === 'quantity'){
      newData.value = calcValue(value, model.price)
    } else if (field === 'price'){
      newData.value = calcValue(model.quantity, value)
    }

    setModel((prevState) => ({
      ...prevState,
      ...newData,
    }))
  };

  const handleGetAssetInfo = () => {
    if (customerId && model && model.isin) {
      const resource = _.get(sharedData, 'resource', PortfolioManagerResource);
      resource.at(`customer/${customerId}/asset-info/?isin=${model.isin}`).get()
      .then((response) => {
        setModel((prevState) => {
          const newData = {...response};
          if(newData.hasOwnProperty('price_date')){
            newData.price_date = dateToMoment(newData.price_date)
          }

          return {
            ...prevState,
            ...newData,
            value: calcValue(model.quantity, response.price),
          }
        });

        setLastSearchedISIN(model.isin);

        dispatch(displaySuccessSnackBar('Das Produkt wurde gefunden. Die entsprechenden Daten wurden vorbefüllt.'))
      })
      .catch((error) => {
        let errorMsg = 'Die Wertpapierinformationen konnten nicht abgeglichen werden.';

        if(_.get(error, 'status') === 404){
          errorMsg = 'Die ISIN wurde leider nicht gefunden.';
        }

        dispatch(displayErrorSnackBar(errorMsg))
      });
    }
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <DisabledCategoryTooltipWrapper isCreate={!defaults.id}>
          <Grid item xs={12}>
            <SelectFormElementV2
              label="Kategorie"
              value={String(ASSET_MODAL_TYPE_NEW.EXTERNAL)}
              options={OTHER_FINANCIAL_CATEGORY.subCategories}
              onChange={handleModelChange('sub_category')}
              dataId={'category-input'}
              disabled
              required
              newDesign
              custom_classes={inputClasses}
            />
          </Grid>
        </DisabledCategoryTooltipWrapper>
      )}
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs>
            <InputFormElement
              label={viewOnly ? "ISIN" : "Produkt suchen"}
              placeholder={'ISIN suchen'}
              error={errors && errors.isin}
              helperText={!viewOnly && model.isin && model.isin !== lastSearchedISIN && 'Das Wertpapier wurde noch nicht abgeglichen.'}
              value={model.isin}
              dataId={'isin-input'}
              disabled={viewOnly}
              custom_classes={inputClasses}
              onChange={handleModelChange('isin')}
            />
          </Grid>
          {!viewOnly && (
            <Grid item xs={'auto'} data-id={'isin-search-btn'}>
              <PrimaryButton
                icon={<i className={"far fa-search"} style={{fontSize: 16}} />}
                text="Suche starten"
                onButtonClick={handleGetAssetInfo}
                style={{height: FORM_FIELD_HEIGHT, marginTop: 16}}
                disabled={!model.isin || model.isin.length < 3} //as cios need at least 3 characters
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Bank / Depotstelle'}
          value={model.custodian}
          error={errors.custodian}
          onChange={handleModelChange('custodian')}
          dataId={'custodian-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Anteile"
          inputComponent={BaseNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          required={!viewOnly}
          value={model.quantity}
          error={errors.quantity}
          onChange={handleModelChange('quantity')}
          dataId={'quantity-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Kurs"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.price}
          error={errors.price}
          onChange={handleModelChange('price')}
          dataId={'price-input'}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <CalendarFormElement
          label="Kursdatum"
          disableFuture
          required={!viewOnly}
          value={model.price_date}
          error={errors.price_date}
          onChange={handleModelChange('price_date')}
          dataId={'price_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputFormElement
          label="Wert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          required={!viewOnly}
          disabled
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Einstandswert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.buy_price}
          error={errors.buy_price}
          onChange={handleModelChange('buy_price')}
          dataId={'buy_price-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Einstandsdatum"
          disableFuture
          value={model.buy_date}
          error={errors.buy_date}
          onChange={handleModelChange('buy_date')}
          dataId={'buy_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

ExternalAssetForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default connect()(ExternalAssetForm);